/**
 * Inventory View — Unified tile grid for equipment and fish
 * Equipment section with inline equip picker + fish inventory grid
 */

import { useGameStore } from '@/state';
import { ScrollableView } from '@/components/layout/ScrollableView';
import { EquipmentSection } from './EquipmentSection';
import { FishInventorySection } from './FishInventorySection';

export function InventoryView() {
  const setCurrentTab = useGameStore((state) => state.setCurrentTab);

  const handleGoToMarkets = () => {
    useGameStore.setState((draft) => {
      draft.currentTab = 'markets';
    });
  };

  return (
    <ScrollableView>
      {/* Equipment tiles with inline equip picker */}
      <EquipmentSection />

      {/* Shop link banner */}
      <div className="bg-gray-800/50 rounded-lg p-4 border border-gray-700 flex items-center justify-between">
        <p className="text-gray-400 text-sm">
          Looking for better gear?
        </p>
        <button
          onClick={() => setCurrentTab('outfitters')}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded font-bold text-sm transition-colors"
        >
          Visit Shop
        </button>
      </div>

      {/* Fish inventory grid with click-to-expand detail */}
      <FishInventorySection onNavigateToMarket={handleGoToMarkets} />
    </ScrollableView>
  );
}
